// web/src/components/OnThisDayWidget.tsx
// Dashboard widget for the "On this day" resurfacing surface (H1.1).
// Renders only when GET /api/v1/on-this-day returns a non-null payload.
// One-line magazine eyebrow + deep link to the historic MatchDetail.

import { Link } from 'react-router-dom';

interface Props {
  data: {
    matchId: string;
    kidId: string;
    kidName: string;
    date: string;
    yearsAgo: number;
    summary: string;
  };
}

export function OnThisDayWidget({ data }: Props) {
  const href = `/kids/${encodeURIComponent(data.kidId)}/matches/${encodeURIComponent(data.matchId)}`;
  return (
    <Link
      to={href}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--space-base)',
        padding: '12px 16px',
        borderRadius: 12,
        background: 'var(--surface-raised, #fff)',
        border: '1px solid var(--divider)',
        textDecoration: 'none',
        color: 'var(--ink)',
        marginTop: 'var(--space-base)',
      }}
    >
      <div
        aria-hidden
        style={{
          fontFamily: 'var(--font-masthead)',
          fontStyle: 'italic',
          fontSize: 'clamp(2rem, 5vw, 2.8rem)',
          lineHeight: 0.85,
          color: 'var(--gold)',
        }}
      >
        ↺
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          fontFamily: 'var(--font-body)', fontSize: 'var(--micro)',
          letterSpacing: '0.22em', textTransform: 'uppercase',
          color: 'var(--gold)', fontWeight: 700, marginBottom: 2,
        }}>
          On this day
        </div>
        <div style={{ fontSize: 15, lineHeight: 1.45 }}>{data.summary}</div>
      </div>
      <div style={{
        color: 'var(--muted)', fontSize: 'var(--small)',
        textTransform: 'uppercase', letterSpacing: '0.14em',
        flexShrink: 0,
      }}>
        Read →
      </div>
    </Link>
  );
}
